export const SERVER_ADDRESS = "https://truename.me"
export const IS_DEVELOPMENT = false